<template lang='pug'>
.checkbox
  input.checkbox__input(
    type="checkbox"
    :id="name"
    :disabled="disabled"
    :name="name"
    v-model="value"
    @input="onInput($event.target.checked)"
  )
  label.label(v-html="label" :for="name")
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/style/ui/variables";
.checkbox {
  &__input {
    position: absolute;
    left: -9999px;
    & + .label {
      cursor: pointer;
      color: #595959;
      display: inline-block;
      font-family: $oscine-font-family;
      font-size: 16px;
      line-height: 1.71;
      padding-left: 30px;
      position: relative;
      font-weight: bold;
      &:before {
        border: solid 2px #8e8e93;
        border-radius: 4px;
        content: "";
        height: 20px;
        left: 0;
        transition: border-color 400ms, background-color 400ms;
        top: 3px;
        position: absolute;
        width: 20px;
      }
    }
    &:checked {
      & + .label {
        &:before {
          background: #6320e9 url("~@/assets/icons/check.svg") no-repeat center /
            26px;
          border: solid 2px #6320e9;
        }
      }
    }
    &:disabled {
      & + .label {
        cursor: no-drop;
        opacity: 0.4;
        &:before {
          opacity: 0.4;
        }
      }
    }
  }
}
</style>
